import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlight',
})
export class HighLightPipe implements PipeTransform {
  transform(value: string, searchTerm: string): string {
    const regex = new RegExp(searchTerm, 'gi'); // 'gi' for global and case-insensitive
    return value.replace(regex, match => `<strong>${match}</strong>`);
  }
}
